import React from 'react';

export default () => (
  <svg height="39px" width="32px" version="1.1" viewBox="0 0 42 39">
    <g id="Page-1" fill="none" stroke="none" strokeWidth="1">
      <g id="250-icons-48x48px" fill="#0074d9" transform="translate(-172.000000, -295.000000)">
        <g id="User" transform="translate(172.000000, 295.000000)">
          <path
            id="Shape"
            d="M20.72,24.4 C26.23,24.4 30.72,19.02 30.72,12.4 C30.72,5.78 26.23,0.4 20.72,0.4 C15.21,0.4 10.72,5.78 10.72,12.4 C10.72,19.02 15.22,24.4 20.72,24.4 Z M20.72,3.4 C24.59,3.4 27.72,7.4 27.72,12.4 C27.72,17.4 24.59,21.4 20.72,21.4 C16.85,21.4 13.72,17.4 13.72,12.4 C13.72,7.4 16.85,3.4 20.72,3.4 Z"
          />
          <path
            id="Shape"
            d="M29.87,23.4 C29.0415729,23.3171574 28.3028428,23.9215729 28.2200001,24.75 C28.1371574,25.5784271 28.7415729,26.3171572 29.57,26.4 C34.2220217,26.9466417 37.8261361,30.7271813 38.15,35.4 L3.29,35.4 C3.64447798,30.740744 7.23298756,26.9765731 11.87,26.4 C12.6984271,26.3171573 13.3028427,25.5784271 13.22,24.75 C13.1371573,23.9215729 12.3984271,23.3171573 11.57,23.4 C11.46,23.4 0.22,24.68 0.22,36.89 C0.22,37.7184271 0.891572875,38.39 1.72,38.39 L39.72,38.39 C40.5484271,38.39 41.22,37.7184271 41.22,36.89 C41.22,24.68 29.98,23.4 29.87,23.4 Z"
          />
        </g>
      </g>
    </g>
  </svg>
);
